import { Modal } from 'antd';
import { AppState } from 'interface/stateApp';
import { Ticket } from 'model/QnA';
import QuestionAndAnswerTicket from '../questionAndAnswerTicket';

interface AuthFormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  isModalType?: boolean;
  onData?: any;
  ticket?: Ticket | null;
  modalKey: any;
}

export default function QuestionAndAnswerTicketModal({
  stateApp,
  setStateApp,
  ticket,
  onData,
  modalKey,
}: AuthFormProps) {
  const { showQnTicketForm } = stateApp;

  return (
    <Modal
      open={showQnTicketForm}
      onCancel={() =>
        setStateApp({
          ...stateApp,
          showQnTicketForm: false,
        })
      }
      footer={[]}
      className="mx-auto w-full md:!w-[70vw] rounded-full login-modal"
    >
      <div className="p-[15px]">
        <QuestionAndAnswerTicket ticket={ticket} onData={onData} modalKey={modalKey} />
      </div>
    </Modal>
  );
}
